// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PathIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PathIcon" ref={forwardedRef} {...props}>
      <path d="M7.313 5.75a2.751 2.751 0 1 1 .142-1.5H14.5a1.25 1.25 0 0 1 1.25 1.25v4a1.25 1.25 0 0 1-1.25 1.25H5.75v3.5h6.938a2.751 2.751 0 1 1-.143 1.5H5.5a1.25 1.25 0 0 1-1.25-1.25v-4A1.25 1.25 0 0 1 5.5 9.25h8.75v-3.5zM6 4.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m9.25 11.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PathIcon = /* @__PURE__ */ Object.assign(PathIconComponent, {
  displayName: 'PathIcon',
});
